// Phase 25 iter-7 — User avatar upload schemas.
//
//   POST /api/v1/users/me/avatar/upload-url  → pre-signed PUT URL
//   PATCH /api/v1/users/me/avatar             → set User.avatar_url
//
// Same S3 presigned-PUT pattern as animal-photo.ts; we cap at 2 MB since
// avatars are tiny (256×256 ish) and we never need raw camera output.
import { z } from 'zod';
export const AVATAR_UPLOAD_MAX_BYTES = 2 * 1024 * 1024;
export const AVATAR_UPLOAD_URL_TTL_SECONDS = 300;
export const AvatarUploadUrlRequestSchema = z
    .object({
    content_length: z.number().int().positive().max(AVATAR_UPLOAD_MAX_BYTES),
    content_type: z.enum(['image/jpeg', 'image/png', 'image/webp']),
})
    .strict();
export const AvatarUploadUrlResponseSchema = z.object({
    upload_url: z.string().url(),
    public_url: z.string().url(),
    expires_at: z.string().datetime({ offset: true }),
    key: z.string().min(1),
    max_bytes: z.number().int().positive(),
});
export const AvatarUpdateRequestSchema = z
    .object({
    avatar_url: z.string().url().max(2048).nullable(),
})
    .strict();
export const AvatarUpdateResponseSchema = z.object({
    avatar_url: z.string().nullable(),
});
//# sourceMappingURL=avatar.js.map